import { RootState } from "@/store";
import { useSelector } from "react-redux";

export const useOfmFiltersState = () =>
  useSelector((s: RootState) => s.ofmFilters);